/*
 * @LastEditors: zhanglinju
 */
/*
 * @LastEditors: zhanglinju
 */
import yxpapi from '@yxpapi';

const api = new yxpapi.PHPAPI({
    // /* 模拟登录 */
    // doLogin: {
    //     url: '/api/user/account/login',
    //     options: {
    //         auth: false,
    //     },
    // },
    // /* 获取用户可访问的路由 */
    // getRouterMap: {
    //     url: '/api/user/address/member/listUserAppPrivileges',
    //     method: 'get',
    // },
    // /* 获取个人之下的单位信息 */
    // getMySubordinate: {
    //     url: '/api/user/account/getOrgInfo',
    //     method: 'get',
    // },
    // /* 查询是否有行政校或培训校学校 */
    // getStudentManageMenu: {
    //     url: '/api/user/account/getStudentManageMenu',
    //     options: {
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    //         },
    //     },
    // },
    /* 内容详情 */
    // 分页获取内容列表
    getPageList: {
        url: '/api/crm/website/content/pageList',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 复制内容
    copyContent: {
        url: '/api/crm/website/content/copyContent',
        method: 'get',
    },
    // 启用禁用
    changeContentStatus: {
        url: '/api/crm/website/content/changeStatus',
        method: 'get',
    },
    // 上移下移
    changeRank: {
        url: '/api/crm/website/content/changeRank',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 删除
    remove: {
        url: '/api/crm/website/content/remove',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    /* 内容制作 */
    // 内容详情
    getInfo: {
        url: '/api/crm/website/content/getInfo',
        method: 'get',
    },
    // 站点标签列表
    getTagList: {
        url: '/api/crm/website/content/tagList',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        },
    },
    getTagListBySiteId: {
        url: '/api/crm/site/getTagListBySiteId',
        method: 'get',
    },
    // 添加标签
    addTag: {
        url: '/api/crm/site/addTag',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 添加标签
    delTag: {
        url: '/api/crm/site/delTag',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 预览
    previewSave: {
        url: '/api/crm/contentLog/previewSave',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 保存内容详情
    make: {
        url: '/api/crm/website/content/save',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    /* 获取站点信息 */
    websiteInfo: {
        url: '/api/crm/website/info',
        method: 'get',
    },
    // 获取友情链接列表
    getPartnerPageList: {
        url: '/api/crm/website/partner/pageList',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 添加友情链接
    savePartner: {
        url: '/api/crm/website/partner/save',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 删除友情链接
    removePartner: {
        url: '/api/crm/website/partner/remove',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 移动友情链接
    changeRankPartner: {
        url: '/api/crm//website/partner/changeRank',
        method: 'get',
    },
    /* 站点栏目 */
    // 站点栏目树列表
    getTreeList: {
        url: '/api/crm/catalog/treeList',
        method: 'get',
    },
    getPageManagePlugList: {
        url: '/api/crm/plug/list',
        method: 'get',
    },
    getColumnInfo: {
        url: '/api/crm/catalog/info',
        method: 'get',
    },
    // 栏目禁用启用
    changeStatus: {
        url: '/api/crm/catalog/changeStatus',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 保存当前栏目
    save: {
        url: '/api/crm/catalog/save',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 栏目上移下移
    move: {
        url: '/api/crm/catalog/move',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 站点父级栏目列表
    getparentList: {
        url: '/api/crm/catalog/parentList',
        method: 'get',
    },
    // 轮播图列表
    getRotationList: {
        url: '/api/crm/rotation/list',
        method: 'get',
    },
    // 启用禁用轮播图
    updateStatusRotation: {
        url: '/api/crm/rotation/updateStatus',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        },
    },
    // 删除轮播图
    deleteRotation: {
        url: '/api/crm/rotation/delete',
        method: 'get',
    },
    // 修改轮播图
    setRotation: {
        url: '/api/crm/rotation/update',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 添加轮播图
    addRotation: {
        url: '/api/crm/rotation/add',
        method: 'post',
        options: {
            headers: { 'Content-Type': 'application/json' },
        },
    },
    // 添加轮播图
    catalogStyleList: {
        url: '/api/crm/catalogStyle/list',
        method: 'get',
    },
    siteStyleSLists: {
        url: '/api/crm/siteStyle/list',
        method: 'get',
    },
    install: {
        url: '/api/crm/common/install',
        method: 'get',
    },
    // 切换样式
    checkStyle: {
        url: '/api/crm/catalogStyle/checkStyle',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    },
    // 切换样式
    checkPlug: {
        url: '/api/crm/plug/check',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    },
    getModuleList: {
        url: '/api/crm/site/getModuleList',
        method: 'get',
    },
    // 查询栏目列表树
    getNavi: {
        url: '/api/crm/website/navigation/treeList',
        method: 'get',
    },
    // 搜索栏目树
    searchTreeList: {
        url: '/api/crm/website/navigation/searchTreeList',
        method: 'get',
    },
    // 设置导航栏
    addNavi: {
        url: '/api/crm/website/navigation/add',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    },
    // 移动导航栏
    moveNavi: {
        url: '/api/crm/website/navigation/changeRank',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    },
    // 删除导航栏
    deleteNavi: {
        url: '/api/crm/website/navigation/delete',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    },
    // 设置链接图标显示方式
    setShowLink: {
        url: '/api/crm/website/update/showLabel',
        method: 'get',
    },
    // 获取链接图标显示方式
    getShowLink: {
        url: '/api/crm/website/select/label',
        method: 'get',
    },

    // 设置导航栏
    addHomePage: {
        url: '/api/crm/website/homePageContent/save',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    },
    // 移动导航栏
    moveHomePage: {
        url: '/api/crm/website/homePageContent/changeRank',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/json',
            },
        },
    },
    // 删除导航栏
    deleteHomePage: {
        url: '/api/crm/website/homePageContent/delete',
        method: 'post',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        },
    },

    // 查询栏目列表树
    getHomePage: {
        url: '/api/crm/website/homePageContent/list',
        method: 'get',
    },
    // 查询栏目列表树
    getHomePageStyle: {
        url: '/api/crm/website/homePageContent/searchContentStyleList',
        method: 'get',
    },
    // 内容标题列表
    getHomePageTitleList: {
        url: '/api/crm/website/homePageContent/searchContentTitleList',
        method: 'get',
    },

});

export default api;
